export default "__VITE_ASSET__BYJ0WSqq__";